module.exports = __webpack_public_path__ + "static/media/menuObject.e380562c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuObject.svg
// module id = 478
// module chunks = 0